module.exports = __webpack_public_path__ + "img/img_8.1e9a3667.svg";